<template>
  <!--
    We cannot use dynamic Ids to be used for the scrollTo,
    since Vue even if the computed and data change
    it doesn't re-render the template before the PDPSectionTabs fires the scrollTo
  -->
  <div :id="activeTab">
    <div>
      <h3 class="pdp-section-header mb-4 font-weight-bold">
        Questions & Reviews
      </h3>

      <PDPSearch v-if="searchIsEnable" />

      <ul class="nav nav-tabs">
        <li class="nav-item" role="presentation">
          <button
            class="btn nav-link"
            :class="{ 'active': activeTab === DISCUSSION_TABS.QUESTIONS }"
            data-toggle="tab"
            role="tab"
            :aria-controls="DISCUSSION_TABS.QUESTIONS"
            :disabled="isFetching"
            :aria-selected="activeTab === DISCUSSION_TABS.QUESTIONS ? 'true' : 'false'"
            @click.stop="setActiveTab(DISCUSSION_TABS.QUESTIONS)"
            @keydown.enter.stop="setActiveTab(DISCUSSION_TABS.QUESTIONS)"
          >
            Questions
            <small v-if="questionsAmount">({{ questionsAmount }})</small>
          </button>
        </li>
        <li
          v-if="!deal.is_info"
          class="nav-item"
          role="presentation"
        >
          <button
            class="btn nav-link"
            :class="{ 'active': activeTab === DISCUSSION_TABS.REVIEWS }"
            data-toggle="tab"
            role="tab"
            :aria-controls="DISCUSSION_TABS.REVIEWS"
            :aria-selected="activeTab === DISCUSSION_TABS.REVIEWS ? 'true' : 'false'"
            :disabled="isFetching"
            @click.stop="setActiveTab(DISCUSSION_TABS.REVIEWS)"
            @keydown.enter.stop="setActiveTab(DISCUSSION_TABS.REVIEWS)"
          >
            Reviews
            <small v-if="reviewsAmount">({{ reviewsAmount }})</small>
          </button>
        </li>
      </ul>

      <div id="disussionTab" class="tab-content">
        <PDPDiscussionContent
          v-show="activeTab === DISCUSSION_TABS.QUESTIONS"
          :key="DISCUSSION_TABS.QUESTIONS"
          class="tab-pane fade pdp-section"
          :class="{ 'show active': activeTab === DISCUSSION_TABS.QUESTIONS }"
          role="tabpanel"
          :aria-labelledby="`${DISCUSSION_TABS.QUESTIONS}-tab`"
          :filter-comments="filterComments"
          :deal="deal"
          :user="user"
          :comment-type="DISCUSSION_TYPE.question"
        />
        <PDPDiscussionContent
          v-show="activeTab === DISCUSSION_TABS.REVIEWS"
          :key="DISCUSSION_TABS.REVIEWS"
          class="tab-pane pdp-section"
          :class="{ 'show active': activeTab === DISCUSSION_TABS.REVIEWS }"
          role="tabpanel"
          :aria-labelledby="`${DISCUSSION_TABS.REVIEWS}-tab`"
          :filter-comments="filterComments"
          :deal="deal"
          :user="user"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DiscussionType, DISCUSSION_TABS } from '../../../constants/discussions';
import PDPDiscussionContent from './PDPDiscussionContent';
import PDPSearch from './PDPSearch.vue';

export default {
  components: {
    PDPDiscussionContent,
    PDPSearch,
  },
  props: {
    filterComments: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    deal: {
      type: Object,
      required: true,
    },
  },
  async fetch() {
    this.$store.dispatch('discussion/setQuestionsAmount', this.deal?.deal_comment?.comment_count || 0);
    this.$store.dispatch('discussion/setReviewsAmount', this.deal?.deal_review?.review_count || 0);

    await this.$store.dispatch('discussion/fetchUserStats', this.deal.id);

    const filterExperiment = await this.$experiments.enroll('pdp-discussion-filters');
    this.$store.dispatch('discussion/setplusFilterExperiment', filterExperiment);
  },
  computed: {
    searchIsEnable() {
      return this.deal?.discussion?.search_is_active || false;
    },
    ...mapGetters('discussion', ['reviewsAmount', 'questionsAmount', 'isFetching', 'activeTab']),
  },
  created() {
    this.DISCUSSION_TYPE = DiscussionType;
    this.DISCUSSION_TABS = DISCUSSION_TABS;
  },
  methods: {
    setActiveTab(tab) {
      this.$store.dispatch('discussion/setActiveTab', tab);

      // Fire event so the 'popstate' in PDPSectionTabs can change the new selected tab
      window.history.pushState({}, '', `#${tab}`);
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-tabs {
  background: transparent;
  margin: 0;
  padding: 0;

  .nav-link {
    background-color: #f5f5f5 !important;
    border-radius: 0;
    border: 1px solid #ddd;
    border-bottom-color: transparent;
    font-family: inherit;
    font-size: 1rem;
    margin: 0 0 -1px;
    padding: 20px 30px;
    position: relative;

    &:focus {
      box-shadow: none;
    }

    &.active {
      background-color: #fff !important;
      border-bottom-color: transparent !important;
    }

    &.active::before {
      background-color: #0275d8;
      content: '';
      inset: -1px -1px auto;
      left: 0;
      height: 3px;
      position: absolute;
    }
  }
}
</style>
